// Formats a chart X-axis tick / tooltip-header date for a data point's raw `time` value.
// - Single-day dataset + showTime: time-only ("10:00 AM").
// - Otherwise: date-only ("Apr 27"), or "<date> <time>" ("Apr 27, 10:00 AM"-style — actually
//   space-joined, see below) when showTime is true.
// Uses the host's local timezone via native Date/toLocaleDateString/toLocaleTimeString by default.
// Passing `utc: true` renders in UTC instead (opt-in seam added by the cloudy-ai-usage-daily-users
// initiative — docs/plans/active/root/2026-07-15-cloudy-ai-usage-daily-users/plan.md "Design"
// section — for the AI Usage page's Cost AND Usage charts). Extracted verbatim from
// MonitoringChart.jsx's inline `formatDate` — default (utc omitted/false) behavior unchanged. The
// caller (MonitoringChart.jsx) still wraps the DEFAULT (non-utc) path in its own `useCallback` with a
// deps array of `[isSingleDay]` only, so the pre-existing "showTime missing from deps" memoization
// behavior characterized in MonitoringChart.test.jsx is unaffected by this extraction; the utc path
// bypasses that memoization entirely (see MonitoringChart.jsx).
const formatDate = (date, { isSingleDay, showTime, utc = false }) => {
  const dateObj = new Date(date);
  const zoneOption = utc ? { timeZone: 'UTC' } : {};

  if (isSingleDay && showTime) {
    return dateObj.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      ...zoneOption
    });
  }

  const dateOptions = { month: 'short', day: 'numeric', ...zoneOption };
  const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: true, ...zoneOption };
  const datePart = dateObj.toLocaleDateString('en-US', dateOptions);
  if (!showTime) {
    return datePart;
  }
  const timePart = dateObj.toLocaleTimeString('en-US', timeOptions);
  return `${datePart} ${timePart}`;
};

export default formatDate;
